import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a package placed in hands to mean that it's been delivered.
 */
export function PackageInHandsIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9975 21.0038H3.99667C3.44416 21.0038 2.99625 20.5559 2.99625 20.0033V14.0008C2.99625 13.4483 3.44416 13.0004 3.99667 13.0004H5.9975C6.55002 13.0004 6.99792 13.4483 6.99792 14.0008V20.0033C6.99792 20.5559 6.55002 21.0038 5.9975 21.0038Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.5006 3.99667V8.59858"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M20.0033 14.0008V10.0392C20.0006 9.24315 19.3548 8.59913 18.5587 8.59859H8.44252C7.64647 8.59913 7.00067 9.24315 6.99792 10.0392V15.1013"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.99792 14.0008V7.96932C6.99813 7.57907 7.07707 7.19288 7.23001 6.83385L8.02134 4.98308C8.27702 4.3846 8.86516 3.99644 9.51597 3.99666H17.4843C18.1371 3.99456 18.728 4.38294 18.9849 4.98308L19.7762 6.83585C19.9277 7.19516 20.005 7.58139 20.0034 7.97132V14.486"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.0004 17.0021H15.3344C15.7673 17.0021 16.1886 16.8617 16.5349 16.6019L18.9519 14.7892C19.5553 14.3368 20.3995 14.397 20.9327 14.9302C21.217 15.2143 21.3768 15.5997 21.3768 16.0017C21.3768 16.4036 21.217 16.789 20.9327 17.0731L18.8589 19.147C18.3002 19.7057 17.5887 20.0865 16.814 20.2414L13.8828 20.8277C13.3016 20.9439 12.702 20.9295 12.1271 20.7857L9.47595 20.1234C9.15901 20.0435 8.8334 20.0032 8.50655 20.0033H6.99792"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.0004 17.0021H14.486C15.3231 17.0021 16.0017 16.3235 16.0017 15.4864V15.1863C16.0017 14.4912 15.5286 13.8852 14.8542 13.7167L12.5612 13.1435C12.1887 13.0495 11.806 13.0014 11.4218 13.0004C10.4941 13.0001 9.58724 13.2748 8.81567 13.7897L6.99792 15.0012"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
